//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { goTo } from '@changba/funny';
import { defineComponent } from '../utils/create';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "double",
    class: {
      'with-bottom': _vm.hasOwn && _vm.showBottom
    }
  }, [_vm.highlightTop3 ? _c('div', {
    staticClass: "double-top"
  }, _vm._l(_vm.topList, function (ref, topIdx) {
    var className = ref.className;
    var data = ref.data;
    return _c('div', {
      key: 'top' + topIdx,
      staticClass: "double-top-item",
      class: className + ' ' + (_vm.hasLoveIcon ? 'love-icon' : '')
    }, [_vm._t("top-couple", function () {
      return [_c('div', {
        staticClass: "top-couple-avatar u1",
        on: {
          "click": function ($event) {
            return _vm.goto(data[_vm.cpProp] && data[_vm.cpProp][0]);
          }
        }
      }, [data && data[_vm.cpProp] && data[_vm.cpProp][0] ? _c('CbImage', _vm._b({
        staticClass: "avatar-img",
        attrs: {
          "src": data[_vm.cpProp][0][_vm.headphotoProp],
          "alt": "用户头像"
        }
      }, 'CbImage', _vm.imgConfig, false)) : _c('span', [_vm._v(_vm._s(_vm.emptyText))])], 1), _vm._v(" "), _c('div', {
        staticClass: "top-couple-avatar u2",
        on: {
          "click": function ($event) {
            return _vm.goto(data[_vm.cpProp] && data[_vm.cpProp][1]);
          }
        }
      }, [data && data[_vm.cpProp] && data[_vm.cpProp][1] ? _c('CbImage', _vm._b({
        staticClass: "avatar-img",
        attrs: {
          "src": data[_vm.cpProp][1][_vm.headphotoProp],
          "alt": "用户头像"
        }
      }, 'CbImage', _vm.imgConfig, false)) : _c('span', [_vm._v(_vm._s(_vm.emptyText))])], 1), _vm._v(" "), _c('span', {
        staticClass: "top-couple-nickname"
      }, [_vm._v("\n          " + _vm._s(data && data[_vm.cpProp] && data[_vm.cpProp].length >= 2 ? data[_vm.cpProp][0][_vm.nicknameProp] + "/" + data[_vm.cpProp][1][_vm.nicknameProp] : _vm.emptyText + "/" + _vm.emptyText) + "\n        ")])];
    }, {
      "item": data,
      "index": topIdx
    }), _vm._v(" "), _vm._t("top-score", function () {
      return [_c('span', {
        staticClass: "top-couple-score"
      }, [_vm._v("\n          " + _vm._s(data ? "" + (data[_vm.pointProp] || 0) + _vm.unit : "0" + _vm.unit) + "\n        ")])];
    }, {
      "item": data,
      "index": topIdx
    })], 2);
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "double-wrapper"
  }, [_vm.normalList.length > 0 ? _c('div', {
    staticClass: "double-container"
  }, _vm._l(_vm.normalList, function (row, rowIdx) {
    return _c('div', {
      key: 'item' + rowIdx,
      staticClass: "double-item"
    }, [_c('span', {
      staticClass: "double-item__rank",
      class: {
        plain: !_vm.highlightTop3
      },
      attrs: {
        "data-index": rowIdx
      }
    }, [_vm._v("\n          " + _vm._s(row[_vm.rankProp]) + "\n        ")]), _vm._v(" "), _vm._t("item-couple", function () {
      return [_c('div', {
        staticClass: "double-item__couple"
      }, [_c('div', {
        staticClass: "couple"
      }, [_c('div', {
        staticClass: "couple-wrapper",
        on: {
          "click": function ($event) {
            return _vm.goto(row[_vm.cpProp] && row[_vm.cpProp][0]);
          }
        }
      }, [row[_vm.cpProp] && row[_vm.cpProp][0] ? _c('CbImage', _vm._b({
        staticClass: "couple-wrapper-img",
        attrs: {
          "src": row[_vm.cpProp][0][_vm.headphotoProp],
          "alt": "用户头像"
        }
      }, 'CbImage', _vm.imgConfig, false)) : _vm._e()], 1), _vm._v(" "), _c('p', {
        staticClass: "couple-nickname"
      }, [_vm._v("\n                " + _vm._s(row[_vm.cpProp] && row[_vm.cpProp][0] ? row[_vm.cpProp][0][_vm.nicknameProp] : _vm.emptyText) + "\n              ")])]), _vm._v(" "), _c('div', {
        staticClass: "love-icon"
      }), _vm._v(" "), _c('div', {
        staticClass: "couple"
      }, [_c('div', {
        staticClass: "couple-wrapper",
        on: {
          "click": function ($event) {
            return _vm.goto(row[_vm.cpProp] && row[_vm.cpProp][1]);
          }
        }
      }, [_c('CbImage', _vm._b({
        staticClass: "couple-wrapper-img",
        attrs: {
          "src": row[_vm.cpProp] && row[_vm.cpProp][1][_vm.headphotoProp],
          "alt": "用户头像"
        }
      }, 'CbImage', _vm.imgConfig, false))], 1), _vm._v(" "), _c('p', {
        staticClass: "couple-nickname"
      }, [_vm._v("\n                " + _vm._s(row[_vm.cpProp] && row[_vm.cpProp][1] ? row[_vm.cpProp][1][_vm.nicknameProp] : _vm.emptyText) + "\n              ")])])])];
    }, {
      "item": row,
      "index": rowIdx + 3
    }), _vm._v(" "), _vm._t("item-score", function () {
      return [_c('span', {
        staticClass: "double-item__score"
      }, [_vm._v("\n            " + _vm._s((row[_vm.pointProp] || 0) + _vm.unit) + "\n          ")])];
    }, {
      "item": row,
      "index": rowIdx + 3
    })], 2);
  }), 0) : _vm.normalList.length === 0 && _vm.selfShowEmptyText ? _c('div', {
    staticClass: "double-empty"
  }, [_vm._v("\n      " + _vm._s(_vm.emptyText) + "\n    ")]) : _vm._e()]), _vm._v(" "), _vm.hasOwn && _vm.showBottom ? _c('div', {
    staticClass: "double-bottom",
    class: {
      'is-fixed': _vm.fixedBottom
    }
  }, [_c('div', {
    staticClass: "double-bottom-inner"
  }, [_vm.own && _vm.own[_vm.cpProp] && _vm.own[_vm.cpProp].length >= 2 ? [_c('span', {
    staticClass: "double-item__rank"
  }, [_vm._v(_vm._s(_vm.own[_vm.rankProp]))]), _vm._v(" "), _vm._t("bottom-couple", function () {
    return [_c('div', {
      staticClass: "double-item__couple"
    }, [_c('div', {
      staticClass: "couple"
    }, [_c('div', {
      staticClass: "couple-wrapper",
      on: {
        "click": function ($event) {
          return _vm.goto(_vm.own[_vm.cpProp] && _vm.own[_vm.cpProp][0]);
        }
      }
    }, [_c('CbImage', _vm._b({
      staticClass: "couple-wrapper-img",
      attrs: {
        "src": _vm.own[_vm.cpProp][0][_vm.headphotoProp],
        "alt": "用户头像"
      }
    }, 'CbImage', _vm.imgConfig, false))], 1), _vm._v(" "), _c('p', {
      staticClass: "couple-nickname"
    }, [_vm._v("\n                " + _vm._s(_vm.own[_vm.cpProp][0][_vm.nicknameProp]) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "love-icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "couple"
    }, [_c('div', {
      staticClass: "couple-wrapper",
      on: {
        "click": function ($event) {
          return _vm.goto(_vm.own[_vm.cpProp] && _vm.own[_vm.cpProp][1]);
        }
      }
    }, [_c('CbImage', _vm._b({
      staticClass: "couple-wrapper-img",
      attrs: {
        "src": _vm.own[_vm.cpProp][1][_vm.headphotoProp],
        "alt": "用户头像"
      }
    }, 'CbImage', _vm.imgConfig, false))], 1), _vm._v(" "), _c('p', {
      staticClass: "couple-nickname"
    }, [_vm._v("\n                " + _vm._s(_vm.own[_vm.cpProp][1][_vm.nicknameProp]) + "\n              ")])])])];
  }, {
    "own": _vm.own
  }), _vm._v(" "), _vm._t("bottom-score", function () {
    return [_c('span', {
      staticClass: "double-item__score"
    }, [_vm._v("\n            " + _vm._s((_vm.own[_vm.pointProp] || 0) + _vm.unit) + "\n          ")])];
  }, {
    "own": _vm.own
  })] : _c('div', {
    staticClass: "double-bottom-empty"
  }, [_vm._v(_vm._s(_vm.noCoupleText))])], 2)]) : _vm._e()]);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-6d35fb2a',
  render,
  name: 'CbDoubleRank',
  props: {
    rankList: {
      type: Array,
      required: true,
      default: () => []
    },
    own: {
      type: Object,
      required: true,
      default: () => ({})
    },
    highlightTop3: {
      type: Boolean,
      required: false,
      default: true
    },
    unit: {
      type: String,
      default: '分'
    },
    // emptyText: {
    //   type: String,
    //   default: '虚位以待'
    // },
    noCoupleText: {
      type: String,
      default: '请组成队伍再来上榜喔~'
    },
    openUserProfile: {
      type: Boolean,
      required: false,
      default: false
    },
    hasLoveIcon: {
      type: Boolean,
      default: true
    },
    showBottom: {
      type: Boolean,
      required: false,
      default: true
    },
    fixedBottom: {
      type: Boolean,
      required: false,
      default: false
    },
    fieldsGetter: {
      type: [Object, Function],
      required: false,
      default: () => ({
        cp: 'cp',
        userid: 'userid',
        nickname: 'nickname',
        headphoto: 'headphoto',
        point: 'point',
        rank: 'rank'
      })
    },
    emptyText: {
      type: String,
      required: false,
      default: '暂无数据'
    },
    imgConfig: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    cpProp() {
      return this.fieldsGetter.cp;
    },
    headphotoProp() {
      return this.fieldsGetter.headphoto;
    },
    useridProp() {
      return this.fieldsGetter.userid;
    },
    nicknameProp() {
      return this.fieldsGetter.nickname;
    },
    pointProp() {
      return this.fieldsGetter.point;
    },
    rankProp() {
      return this.fieldsGetter.rank;
    },
    topList() {
      var size = this.highlightTop3 ? 3 : 0;
      var tempList = this.rankList.slice(0, size);
      while (tempList.length < size) {
        tempList.push(null);
      }
      return tempList.map((x, idx) => {
        return {
          data: x,
          className: 'tp' + (idx + 1)
        };
      });
    },
    normalList() {
      var size = this.highlightTop3 ? 3 : 0;
      return this.rankList.slice(size);
    },
    hasOwn() {
      return this.own && Object.keys(this.own).length > 0;
    },
    selfShowEmptyText() {
      if (typeof this.showEmptyText === 'function') {
        return this.showEmptyText({
          normalList: this.normalList,
          topList: this.topList,
          rankList: this.rankList
        });
      }
      return this.showEmptyText;
    }
  },
  methods: {
    goto(user) {
      // emit goto事件出去，可将openUserProfile 设置false自行处理跳转
      this.$emit('goto', user[this.fieldsGetter.userid]);
      if (!this.openUserProfile) {
        return;
      }
      goTo.profile(user[this.fieldsGetter.userid]);
    }
  }
});